import { api } from './common'

export const getTemplatesList = (token) =>
  api({
    method: 'GET',
    path: '/builder/template',
    token,
  })
